// @mui
import { LoadingButton } from '@mui/lab';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

// ----------------------------------------------------------------------

type RejectPendingApprovalModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onAccept: () => void;
  isLoading?: boolean;
};

export default function RejectPendingApprovalModal({
  isOpen,
  onClose,
  onAccept,
  isLoading,
}: RejectPendingApprovalModalProps) {
  const { t } = useTranslation();
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>{t('visit.rejectVisitDialogTitle')}</DialogTitle>

      <DialogContent sx={{ maxWidth: '400px' }}>
        <DialogContentText id="alert-dialog-description">
          {t('visit.rejectPendingConfirm')}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          variant="outlined"
          color="inherit"
          onClick={onClose}
          disabled={isLoading}
        >
          {t('common.close')}
        </Button>
        <LoadingButton
          variant="contained"
          color="error"
          onClick={onAccept}
          disabled={isLoading}
          loading={isLoading}
          data-testid="visit-reject-confirm-button"
        >
          <span>{t('visit.rejectAction')}</span>
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
